<div>
  <button (click)="sendNotification()">send</button>
</div>
<!-- <div *ngFor="let notification of notifications">
    {{ notification.message }}
  </div> -->
